import { Files } from '../../lib/constants/files'
import { AffectedStaffQuestionnaire } from '../../lib/types/models/affected-staff-questionnaire/affected-staff-questionnaire'
import { FileInput } from '../../lib/types/models/file/file-input'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'
import { AffectedStaffQuestionnaireRequest } from './submit-affected-staff-questionnaire'

export async function saveAffectedStaffQuestionnaire(data: AffectedStaffQuestionnaireRequest) {
  const { affectedStaffId: id, input } = data

  if (input.familyImages) {
    const uploadedFamilyImages = await Promise.all(
      input.familyImages.map((file) =>
        uploadFile(Files.AFFECTED_STAFF_QUESTIONNAIRE_FAMILY_IMAGES, file)
      )
    )
    input.familyImages = uploadedFamilyImages.filter(
      (file): file is FileInput => file !== null && file !== undefined
    )
  }

  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.saveAffectedStaffQuestionnaire.url, { id }))
    .post<AffectedStaffQuestionnaire>(input)
}
